// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cutLengthBadgeStyles } from "@steiner/App/Components/CutProducts/CutLengthBadge";
import InfoTooltip from "@steiner/XDL/Icons/InfoTooltip";
import { color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

cutLengthBadgeStyles.container = {
    css: css`
        display: flex;
        align-items: center;
        gap: 8px;
    `,
};

cutLengthBadgeStyles.iconStyles = {
    size: 23,
    color: "primary",
    css: css`
        & rect {
            color: ${color("secondary.main")};
        }
    `,
};

cutLengthBadgeStyles.tooltipStyles = {
    iconProps: {
        src: InfoTooltip,
        color: "primary",
        css: css`
            vertical-align: middle;
            &:hover {
                color: ${color("common.ui9")};
            }
        `,
    },
    floatingTooltipProps: {
        tooltipContent: {
            css: css`
                max-width: 160px;
                padding: 8px 8px 16px;
            `,
        },
    },
};
